import React, { useState, useEffect, useContext } from "react";
import {
  AiOutlineFolderAdd,
  AiOutlineFileAdd,
  AiOutlineFolder,
  AiOutlineFolderOpen,
  AiOutlineDelete,
  AiOutlineEdit
} from "react-icons/ai";
import {
  ActionsWrapper,
  Collapse,
  StyledFolder,
  StyledName,
  VerticalLine
} from "./Tree.style";
import { useTreeContext } from "./TreeContext";
import { PlaceholderInput } from "./TreePlaceholderInput";
import { useSelector, useDispatch } from 'react-redux';
import Actions from "./ActionConst";
import AppContext from "../../../Context/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faFolderOpen } from "@fortawesome/free-solid-svg-icons";

const FolderName = ({ isOpen, name, handleClick}) => (
  <StyledName className="Text-Color" onClick={handleClick}>
    {isOpen ? <FontAwesomeIcon color='#f5c72f' className='mr-1' icon={faFolderOpen} /> : <FontAwesomeIcon color='#f5c72f' className='mr-1' icon={faFolder} />}
    &nbsp;&nbsp; <span className="Elipsis-Class">{name}</span> 
  </StyledName>
);

const Folder = ({ thisData,selectedFile,id,type, name,disableCollapse, level, readOnly, children, parentPath ,actionsAllowed, maxChiledAllow }) => {
  const { state, dispatch, isImparative, onNodeClick, onUpload } = useTreeContext();
  const [isEditing, setEditing] = useState(false);
  const [isOpen, setIsOpen] = useState(false || disableCollapse);
  const FolderPickerSelecetdPath = useSelector((state) => state.AppReduxContext.FolderPickerSelecetdPath); // Read state
  // const appData = AppData || {};
  const [childs, setChilds] = useState([]);
  const openCallback=(flag)=>{
    if(disableCollapse){
      setIsOpen(true);
    }else{
      setIsOpen(flag);
    }
  }
  // increase `level` recursively
  // defaultProps comes in on each cycle
  useEffect(() => {
    const nestedChilds = React.Children.map(children, item => {
      if (item.type === Folder) {
        return React.cloneElement(item, {
          level: level + 1,
          parentPath: `${parentPath}/${name}`
        });
      }
      return item;
    });
    setChilds(nestedChilds);
  }, [children]);

  const handleFileCreation = event => {
    event.stopPropagation();
    openCallback(true);
    setChilds([
      ...childs,
      <PlaceholderInput
        type="file"
        handleSubmit={name => {
          dispatch({ type: "CREATE_FILE", payload: { id, name } });
        }}
      />
    ]);
  };

  const handleFolderCreation = event => {
    event.stopPropagation();
    openCallback(true);
    setChilds([
      ...childs,
      <PlaceholderInput
        type="folder"
        folderLevel={level}
        handleSubmit={name => {
          dispatch({ type: "CREATE_FOLDER", payload: { id, name } });
        }}
      />
    ]);
  };

  const handleDeleteFolder = () => {
    dispatch({ type: "DELETE_FOLDER", payload: { id } });
  };
  const handleFolderRename = name => {
    openCallback(true);
    setEditing(true);
  };

  return (
    <StyledFolder
      
      onClick={event => {
        event.stopPropagation();
        onNodeClick({
          state,
          name,
          level,
          id,
          path: `${parentPath}/${name}`,
          prevUrl: thisData.prevUrl,
          type: "folder"
        });
      }}
      className="tree__folder"
      indent={level}
    >
      <VerticalLine className="Vertical-Line">
        <ActionsWrapper className={`Parent-Class  ${(selectedFile?.id == id || FolderPickerSelecetdPath?.includes(id)) && "Selected"}`}>
          {isEditing ? (
            <PlaceholderInput
              type="folder"
              style={{ marginLeft: 0 }}
              folderLevel={level - 2}
              defaultValue={name}
              handleSubmit={name => {
                dispatch({ type: "RENAME_FOLDER", payload: { id, name } });
                setEditing(false);
              }}
            />
          ) : (
            <FolderName
              name={name}
              isOpen={isOpen}
              handleClick={() => openCallback(!isOpen)}
            />
          )}

          {isImparative && (
            <div className="actions mr-2">
              {!readOnly && (actionsAllowed ? actionsAllowed.includes(Actions.EDIT): true) && <AiOutlineEdit onClick={handleFolderRename} />}
              {(actionsAllowed ? actionsAllowed.includes(Actions.ADD_FILE): true) && (maxChiledAllow ?  childs.length < maxChiledAllow : true) && <AiOutlineFileAdd onClick={handleFileCreation} />}
              {(actionsAllowed ? actionsAllowed.includes(Actions.ADD_FOLDER): true) && (maxChiledAllow ?  childs.length < maxChiledAllow : true) && <AiOutlineFolderAdd onClick={handleFolderCreation} />}
              {!readOnly && (actionsAllowed ? actionsAllowed.includes(Actions.DELETE): true) && <AiOutlineDelete onClick={handleDeleteFolder} />}
            </div>
          )}
        </ActionsWrapper>
        <Collapse className="tree__folder--collapsible" isOpen={isOpen}>
          {childs}
        </Collapse>
      </VerticalLine>
    </StyledFolder>
  );
};
Folder.defaultProps = { level: 1, parentPath: "" };

export { Folder, FolderName };
